module.exports = __webpack_public_path__ + "static/images/containers/EloLeaderboard/images/tab-bg_hover.59268b70.png";


//////////////////
// WEBPACK FOOTER
// ./containers/EloLeaderboard/images/tab-bg_hover.png
// module id = 3103
// module chunks = 11